import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";


@Component({
    selector: 'app-payment-declined-dialog',
    template: require('./payment-declined.dialog.html')
})
export class PaymentDeclinedDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<PaymentDeclinedDialog>) public dialogRef: MatDialogRef<PaymentDeclinedDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
